<template>
  <a-form-item
    :label="varLabel"
    :label-col="formItemLayout.labelCol"
    :wrapper-col="formItemLayout.wrapperCol"
  >
    <a-input
      :size="size"
      :disabled="disabled"
      :addonBefore="prefix"
      v-decorator="[varName, { 
                    rules: [{ required: varRequired, message: message}],
                    initialValue: varInitial
                    }]"
      :placeholder="varLabel"
      :type="varType"
    >
      <a-icon
        type="copy"
        slot="addonAfter"
        style="fontSize:20px;cursor: pointer; padding:5px;"
        v-clipboard:copy="value"
        @click="success"
      />
    </a-input>
    <a-alert :message="description" type="info" showIcon style="margin-top:5px;" v-if="description" />
  </a-form-item>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  mixins: [formLayoutMixin],
  props: {
    varName: String,
    varLabel: String,
    varInitial: String,
    varRequired: Boolean,
    formLayout: String,
    size: String,
    prefix: [String, null],
    description: [String, null],
    disabled: {
      type: Boolean,
      default: false
    },
    varType: {
      type: String,
      default: "string"
    },
    value: String
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  },
  methods: {
    success() {
      this.$message.success("Copied.", 5);
    }
  },
};
</script>
